import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["language"];
import { registerQuery, useQuery } from '../../../utils/DataFetchingClient';
import getLang from '../../../utils/getLang';
import { rpcClient } from '../../../client';
import { getMLRecommendationsRpc } from 'academy-service-client/academy-recommendations/v2/operations';
export const GET_ML_RECOMMENDATIONS = registerQuery({
  fieldName: 'MlRecommendations',
  args: ['language', 'size'],
  fetcher(_ref) {
    let {
        language
      } = _ref,
      queryParameters = _objectWithoutPropertiesLoose(_ref, _excluded);
    return rpcClient.call(getMLRecommendationsRpc, {
      queryParameters,
      pathParameters: {
        language
      }
    });
  }
});
export const useMlRecommendations = ({
  skip,
  language = getLang().toUpperCase(),
  size = 5
}) => {
  const {
    data: MlRecommendationsResponse,
    loading: MlRecommendationsLoading,
    error: MlRecommendationsError,
    apolloError
  } = useQuery(GET_ML_RECOMMENDATIONS, {
    skip,
    variables: {
      language,
      size
    }
  });
  const explanations = MlRecommendationsResponse === null || MlRecommendationsResponse === void 0 ? void 0 : MlRecommendationsResponse.explanations;
  return {
    MlRecommendations: MlRecommendationsResponse === null || MlRecommendationsResponse === void 0 ? void 0 : MlRecommendationsResponse.results,
    correlationId: MlRecommendationsResponse === null || MlRecommendationsResponse === void 0 ? void 0 : MlRecommendationsResponse.correlationId,
    MlRecommendationsLoading,
    MlRecommendationsError,
    apolloError,
    recommendationStrategy: explanations ? explanations['modelUsed'] === 'scann' || explanations['numCompletedContents'] === 0 ? 'cold' : 'warm' : undefined
  };
};